import Button from "../../../general/Button/index";
import Send2 from "../../../../assets/icons/Send2";
import React, { useCallback } from "react";
import { Container, WrapperDiv, CustomMentionInput } from "./styles";

import { Mention } from "react-mentions";

const MessageInput = ({
  newMessage,
  users = [],
  subtasks = [],
  placeholder,
  value,
  setValue,
  style = {},
}) => {
  const mentionStyle = {
    background: "#d6e5fa",
    padding: "0.2rem",
  };

  const mentionsInputStyle = {
    suggestions: {
      item: {
        borderBottom: "1px solid rgba(0,0,0,0.15)",
        "&focused": {
          backgroundColor: "#cee4e5",
        },
      },
    },
  };

  const listSubtasks = subtasks.map(
    (item) =>
      (item = {
        id: item.id,
        display: item.title,
        type: "subtask",
      })
  );

  const listUsers = users.map(
    (item) =>
      (item = {
        id: item._id,
        display: item.username,
        avatarURL: item.avatarURL,
        type: "user",
      })
  );

  const displayTransform = useCallback(
    (id, display) => {
      const els = [...listUsers, ...listSubtasks];
      const item = els.find((i) => i.id === id);

      return item?.type === "subtask" ? `#${display}` : `@${display}`;
    },
    [listSubtasks, listUsers]
  );

  const renderUserSuggestion = useCallback((suggestion) => {
    return (
      <div className="user-mention">
        {suggestion?.avatarURL ? (
          <img src={suggestion.avatarURL} alt="" />
        ) : null}
        <span className="name">{suggestion.display}</span>
      </div>
    );
  }, []);

  const onButtonConfirm = () => newMessage(value);

  return (
    <WrapperDiv style={style}>
      <Container>
        <CustomMentionInput
          onKeyDown={(e) => {
            if (e.key === "Enter" && e.shiftKey) {
              newMessage(value);
              e.preventDefault();
            }
          }}
          style={mentionsInputStyle}
          value={value}
          onChange={(e) => {
            setValue(e.target.value);
          }}
          placeholder={placeholder}
        >
          <Mention
            trigger="@"
            data={listUsers}
            className="suggestions"
            markup="@[__display__](__id__)"
            style={mentionStyle}
            displayTransform={displayTransform}
            renderSuggestion={renderUserSuggestion}
          />
          <Mention
            trigger="#"
            data={listSubtasks}
            markup="#[__display__](__id__)"
            className="suggestions"
            style={mentionStyle}
            displayTransform={displayTransform}
            renderSuggestion={renderUserSuggestion}
          />
        </CustomMentionInput>
        <Button onClick={onButtonConfirm} content={<Send2 height="1.8rem" />} />
      </Container>
    </WrapperDiv>
  );
};

export default MessageInput;
